import { render, staticRenderFns } from "./HeaderBrandLink.vue?vue&type=template&id=9b536324&scoped=true&"
import script from "./HeaderBrandLink.vue?vue&type=script&lang=js&"
export * from "./HeaderBrandLink.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBrandLink.vue?vue&type=style&index=0&id=9b536324&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b536324",
  null
  
)

export default component.exports